(function () {
  const openBtn = document.querySelector('#open-perso');
  const modal = document.querySelector('#perso-modal');
  const overlay = document.querySelector('#perso-overlay');
  const closeBtn = document.querySelector('.perso-close');
  const input = document.querySelector('#perso-input');
  const errorEl = document.querySelector('#perso-error');
  const addBtn = document.querySelector('#perso-add');

  if (!openBtn || !modal) return;

  // Helpers
  const open = () => { modal.hidden = false; overlay.hidden = false; input.focus(); };
  const close = () => { modal.hidden = true; overlay.hidden = true; };

  // Ouvrir / fermer
  openBtn.addEventListener('click', open);
  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', (e)=>{ if(e.key === 'Escape') close(); });

  // Validation : MAJ + autoriser A-Z, '.' et '-'
  const allowed = /^[A-Z.\-&]{1,5}$/; // 1 à 5
  const sanitize = (val) => val.toUpperCase().replace(/[^\w.\-]/g, (c) => c); // on monte en MAJ, on ne change pas ., -
  input.addEventListener('input', () => {
    input.value = input.value.toUpperCase();
    if (input.value.length > 5) input.value = input.value.slice(0,5);
    // Affichage d'erreur en live si caractère interdit
    if (!input.value || allowed.test(input.value)) {
      errorEl.hidden = true;
    } else {
      errorEl.hidden = false;
    }
  });

  // Clic "ADD TO CART" (dans la modale)
  addBtn.addEventListener('click', () => {
    const val = (input.value || '').toUpperCase();
    if (!val) {
      // message explicite si vide
      errorEl.textContent = 'Thank you for entering your personalization text to continue.';
      errorEl.hidden = false;
      input.focus();
      return;
    }
    // Re-valider
    errorEl.textContent = 'Your input includes one or more disallowed characters. Kindly revise.';
    if (!allowed.test(val)) {
      errorEl.hidden = false;
      input.focus();
      return;
    }

    // Ajouter la propriété de ligne et soumettre le formulaire produit existant
    const productForm = openBtn.closest('form[action*="/cart/add"]') || document.querySelector('product-form form');
    if (!productForm) return;

    // Crée/MAJ un champ caché pour la propriété
    let prop = productForm.querySelector('input[name="properties[Personalization]"]');
    if (!prop) {
      prop = document.createElement('input');
      prop.type = 'hidden';
      prop.name = 'properties[Personalization]';
      productForm.appendChild(prop);
    }
    prop.value = val;

    // Soumettre
    productForm.requestSubmit ? productForm.requestSubmit() : productForm.submit();
    close();
  });
})();
// --- Met à jour l'image du popup selon la variante sélectionnée ---
(function(){
  const updatePersoImage = () => {
    const img = document.getElementById('perso-modal-img');
    if (!img || !window.PERSO_VARIANT_IMAGES) return;
    // sélecteur de variante (ton thème met "original-selector")
    const sel = document.querySelector('select.original-selector');
    if (!sel) return;
    const url = window.PERSO_VARIANT_IMAGES[sel.value];
    if (url) img.src = url;
  };

  // 1) Au changement de variante
  document.addEventListener('change', (e) => {
    if (e.target && e.target.matches('select.original-selector')) {
      updatePersoImage();
    }
  });

  // 2) À l’ouverture du popup (au cas où l’utilisateur a déjà changé la variante)
  const openBtn = document.querySelector('#open-perso');
  if (openBtn) {
    openBtn.addEventListener('click', () => {
      setTimeout(updatePersoImage, 0);
    });
  }
})();
